import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import { useAlert } from '../context/AlertContext';
import './Modules.css';

function Modules() {
  const [modules, setModules] = useState({});
  const [loading, setLoading] = useState(true);
  const [configModal, setConfigModal] = useState(null);
  const [configValues, setConfigValues] = useState({});
  const alert = useAlert();

  const platforms = {
    'twitch-main': 'Twitch Main',
    'twitch-247': 'Twitch 24/7',
    'youtube': 'YouTube',
    'discord': 'Discord'
  };

  useEffect(() => {
    loadModules();
  }, []);

  const loadModules = async () => {
    try {
      const { data } = await axios.get('/api/modules');
      setModules(data);
      setLoading(false);
    } catch (error) {
      alert.error('Fehler beim Laden der Module');
      setLoading(false);
    }
  };

  const toggleModule = async (platform, moduleName, enabled) => {
    try {
      await axios.post(`/api/modules/${platform}/${moduleName}`, { enabled });
      alert.success(`Modul ${enabled ? 'aktiviert' : 'deaktiviert'}`);
      loadModules();
    } catch (error) {
      alert.error('Fehler beim Ändern des Moduls');
    }
  };

  const openConfig = (platform, moduleName, module) => {
    setConfigModal({ platform, moduleName, module });
    setConfigValues(module.config || {});
  };

  const saveConfig = async () => {
    try {
      await axios.put(`/api/modules/${configModal.platform}/${configModal.moduleName}/config`, configValues);
      alert.success('Konfiguration gespeichert');
      setConfigModal(null);
      loadModules();
    } catch (error) {
      alert.error('Fehler beim Speichern der Konfiguration');
    }
  };

  if (loading) {
    return <div className="modules-page"><div className="loading">Lade Module...</div></div>;
  }

  return (
    <div className="modules-page">
      <div className="page-header">
        <h2>Module Verwaltung</h2>
        <p>Aktiviere oder deaktiviere Module für jeden Service</p>
      </div>

      <div className="modules-grid">
        {Object.entries(platforms).map(([platformKey, platformName]) => (
          <div key={platformKey} className="platform-section">
            <h3>{platformName}</h3>
            
            {modules[platformKey] && Object.entries(modules[platformKey]).map(([moduleKey, module]) => (
              <div key={moduleKey} className="module-card">
                <div className="module-info">
                  <h4>{module.name}</h4>
                  <p className="module-description">{module.description}</p>
                  {module.games && module.games.length > 0 && (
                    <p className="module-games">
                      Enthält: {module.games.join(', ')}
                    </p>
                  )}
                  {module.hasConfig && (
                    <button 
                      className="config-btn"
                      onClick={() => openConfig(platformKey, moduleKey, module)}
                    >
                      ⚙️ Konfigurieren
                    </button>
                  )}
                </div>
                
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={module.enabled}
                    onChange={(e) => toggleModule(platformKey, moduleKey, e.target.checked)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        ))}
      </div>

      {configModal && (
        <div className="modal-overlay" onClick={() => setConfigModal(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Konfiguration: {configModal.module.name}</h3>
            
            {configModal.moduleName === 'obs-stats' && (
              <div className="config-form">
                <label>
                  Intervall (Sekunden):
                  <input
                    type="number"
                    min="60"
                    max="3600"
                    value={configValues.interval || 300}
                    onChange={(e) => setConfigValues({ ...configValues, interval: parseInt(e.target.value) })}
                  />
                </label>
                <p className="config-hint">
                  Wie oft soll die aktuelle Scene im Chat gepostet werden? (60-3600 Sekunden)
                </p>
              </div>
            )}
            
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setConfigModal(null)}>
                Abbrechen
              </button>
              <button className="btn-save" onClick={saveConfig}>
                Speichern
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Modules;
